/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';

import { Container, Items, Item } from './styles';

interface UserStatus {
  key: string;
  value: string;
}

interface Props {
  show: boolean;
  value: any;
  userStatus?: UserStatus[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: string) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectGroups = ({ show, userStatus, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isStatusActive = useCallback((item: UserStatus) => item === value.key, [value]);

  const handleItemClick = (id: string) => {
    if (id !== value) {
      onChange(id);
    }
    onClose();
  };

  const makeStatus = (userStatusField: UserStatus) => userStatusField.value;

  return show ? (
    <Container>
      <Items>
        { 
            userStatus ?
            userStatus.map((t) => (
                <MakeItem
                key={t.key}
                className={isStatusActive(t) ? 'active' : ''}
                text={makeStatus(t)}
                onClick={() => handleItemClick(t.key || '')}
                />
            ))
          :
          null
          }
      </Items>
    </Container>

  ) : null;
};

export default SelectGroups;
